<template>
    <div class="section-2">
        <div class="container">
            <div class="row p-0 m-0">
                <div class="col-12 col-lg-12">
                    <div class="">
                        <router-link to="/" class="fl-x-cl mt-4">
                            <img class="logo" src="../assets/web/login/logoo.png">
                        </router-link>
                        <!--                        <div class="fl-x-cr i-icon">-->
                        <!--                            <p class="mb-1 mr-3 fs&#45;&#45;1 font-lato-light">sign up with</p>-->

                        <!--                            <img class="fb flj-c mr-2" src="../assets/web/login/fb.png">-->

                        <!--                            <img class="gugl fl-j-c" src="../assets/web/login/g.png">-->
                        <!--                        </div>-->
                    </div>
                    <div class="dg-sm-mt" align="center">
                        <p class="font-jost-book  fs-4 mb-2 mg margin-1">Welcome to KLDB Training Programs</p>
                        <p class="font-jost-semi-bold fs-lg-9 mb-0">Registration Portal</p>
                        <p @click="$router.push('/login/')" class="font-inter-regular text-white-2 fs--1 pb-4">Already
                            have an Account ?
                            <a href="#" class="line-bottom text-decoration-none"> Sign in</a></p>

                        <div class="px-lg-9">
                            <p @click="$router.push('/register/')" class="font-lato-semi-bold ml-4 user-reg-in"
                               align="left">Personal Details</p>
                            <b-form :save-url="registerUrl" @success="formSuccess" @failure="formError" v-slot="{model, loading}"
                                    :save-params="{user_type:'Individual', email_verified: emailVerified, phone_verified: phoneVerified}">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <validated-input size="sm" placeholder="Name*" border-radius="0" name="Name"
                                                         id="name" v-model="model.name" :disabled="loading"
                                                         class=" place-holder-white c-input bdr-radius">
                                        </validated-input>
                                    </div>
                                    <div class="col-lg-6">
                                        <validated-input size="sm" placeholder="Create A Password*" border-radius="0"
                                                         name="Password" type="password" id="Password"
                                                         v-model="model.password" :disabled="loading"
                                                         class=" place-holder-white c-input">
                                        </validated-input>
                                    </div>
                                    <div class="col-lg-6">
                                        <validated-vue-select border-radius="0" size="sm" name="Gender"
                                                              class="mb-3 c-input-select-b-white-1 place-holder-white c-input "
                                                              aria-placeholder="Select Gender" :disabled="loading"
                                                              :options="genderOptions" v-model="model.gender"
                                                              placeholder="Gender"></validated-vue-select>
                                    </div>
                                    <div class="col-lg-6">
                                        <validated-input size="sm" placeholder="Confirm New Password*" border-radius="0"
                                                         name="Confirm Password" type="password" id="Confirm Password"
                                                         v-model="model.confirm_password" :disabled="loading"
                                                         class=" place-holder-white c-input">
                                        </validated-input>
                                    </div>

                                    <div class="col-lg-6">
                                        <validated-date-picker value-type="YYYY-MM-DD" format="DD-MM-YYYY" size="sm"
                                                               placeholder="Date Of Birth"
                                                               border-radius="0" v-model="model.dob"
                                                               :disabled="loading" name="Dob"
                                                               style="color: white !important;"
                                                               :disabled-date="disabledDateAfterToday"
                                                               class=" place-holder-white c-input icon-white input-white">
                                        </validated-date-picker>
                                    </div>
                                    <div class="col-lg-6">
                                        <validated-input size="sm" placeholder="House/ Flat No./ Building/Apartment"
                                                         border-radius="0" name="Address" id="Address"
                                                         class=" place-holder-white c-input"
                                                         v-model="model.address" :disabled="loading">
                                        </validated-input>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="verify-wrap">
                                            <validated-input size="sm" placeholder="Phone*" border-radius="0"
                                                             name="Phone Number" type="number" id="Phone"
                                                             v-model="model.phone_number" :rules="{max: 10, min: 10}"
                                                             :disabled="loading" @input="phoneVerified = false"
                                                             class="num-hide place-holder-white c-input">
                                            </validated-input>
                                            <span v-if="phoneVerified" class="verify-done">Verified ✓</span>
                                            <button v-else type="button" class="verify-btn"
                                                    :disabled="loading || sendingOtp !== '' || !model.phone_number"
                                                    @click="verifyPhone(model.phone_number)">
                                                <span v-if="sendingOtp === 'phone'" class="verify-spinner"></span>
                                                {{ sendingOtp === 'phone' ? 'Sending...' : 'Verify' }}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <validated-input size="sm" placeholder="Area/Street/Village" border-radius="0"
                                                         name="Area" id="Area" v-model="model.area"
                                                         :disabled="loading" class="place-holder-white c-input">
                                        </validated-input>
                                    </div>

                                    <div class="col-lg-6">
                                        <div class="verify-wrap">
                                            <validated-input size="sm" placeholder="Email Id*" border-radius="0"
                                                             name="Email" type="email" v-model="model.email"
                                                             :disabled="loading" @input="emailVerified = false"
                                                             class=" place-holder-white c-input">
                                            </validated-input>
                                            <span v-if="emailVerified" class="verify-done">Verified ✓</span>
                                            <button v-else type="button" class="verify-btn"
                                                    :disabled="loading || sendingOtp !== '' || !model.email"
                                                    @click="verifyEmail(model.email)">
                                                <span v-if="sendingOtp === 'email'" class="verify-spinner"></span>
                                                {{ sendingOtp === 'email' ? 'Sending...' : 'Verify' }}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <validated-input size="sm" placeholder="Town/City" border-radius="0"
                                                         name="City" id="City" v-model="model.city"
                                                         :disabled="loading" class="py-1 place-holder-white c-input">
                                        </validated-input>
                                    </div>
                                    <div class="col-lg-6">
                                        <validated-input size="sm" placeholder="Aadhar Number" border-radius="0"
                                                         name="Adhar number" type="number" id="Aadhar Number"
                                                         v-model="model.adhar_number" :rules="{max: 12, min: 12}"
                                                         :disabled="loading"
                                                         class="num-hide place-holder-white c-input">
                                        </validated-input>
                                    </div>
                                    <div class="col-lg-6">
                                        <validated-ajax-vue-select border-radius="0" size="sm" name="State"
                                                                   class="mb-3 c-input-select-b-white-1 place-holder-white c-input "
                                                                   aria-placeholder="Select State"
                                                                   :disabled="loading" :url="stateOptions"
                                                                   v-model="model.state" placeholder="State"/>
                                    </div>
                                    <div class="col-lg-6">
                                        <validated-vue-select border-radius="0" size="sm" name="Marital Status"
                                                              class="mb-3 c-input-select-b-white-1 place-holder-white c-input "
                                                              aria-placeholder="Select Marital Status"
                                                              :disabled="loading" :options="maritalStatusOptions"
                                                              v-model="model.marital_status"
                                                              placeholder="Marital Status"></validated-vue-select>
                                    </div>

                                    <div class="col-lg-6">
                                        <validated-input size="sm" name="Pincode" placeholder="Pincode"
                                                         border-radius="0" v-model="model.pincode" :disabled="loading"
                                                         type="number" class="num-hide place-holder-white c-input">
                                        </validated-input>
                                    </div>
                                    <!--                                    <div class="col-12">-->
                                    <!--                                        <p class="text-white text-left text-danger">Fields marked with an asterisk (*) are required.</p>-->
                                    <!--                                    </div>-->

                                </div>
                                <btn border-radius="0" class="mt-43 fs--1 px-7 py-21 mb-4 bdr-radius"
                                     text="Register"></btn>
                            </b-form>
                        </div>

                    </div>
                </div>
            </div>
            <modal title="Verify OTP" ref="verifyModal" width="30r" header-color="primary" no-close-on-backdrop>
                <p class="mb-3">
                    Enter the code sent to <strong>{{ otpTarget }}</strong>
                </p>
                <b-form :key="otpKey" :save-url="verifyOtpUrl" @success="otpSuccess" @failure="otpError"
                        v-slot="{model, loading}"
                        :save-params="{type: otpType, target: otpTarget}">
                    <div class="row">
                        <div class="col-12">
                            <validated-input type="text" label="OTP" v-model="model.otp"
                                             :rules="{required: true, min: 6, max: 6}" :disabled="loading"/>
                        </div>
                        <div class="col-12 d-flex justify-content-between align-items-center">
                            <div class="btn-group">
                                <btn class="trn" type="button" text="Resend OTP" loading-text="Sending..." size="sm"
                                     :loading="sendingOtp !== ''" :disabled="loading || sendingOtp !== '' || resendIn > 0"
                                     @click="resendOtp"/>
                                <btn class="trn" text="Verify OTP" loading-text="Verifying..." size="sm"
                                     :disabled="loading" :loading="loading"/>
                            </div>
                        </div>
                    </div>
                </b-form>
            </modal>
        </div>
    </div>
</template>

<script>
import urls from '../data/urls';
import axios from 'secure-axios';

export default {
    name: 'RegisterIndividual',
    data () {
        return {
            stateOptions: urls.masterData.State.stateOptions,
            registerUrl: urls.auth.register,
            emailVerified: false,
            phoneVerified: false,
            otpType: '',
            otpTarget: '',
            otpKey: 0,
            sendOtpUrl: urls.auth.sendOtp,
            verifyOtpUrl: urls.auth.verifyOtp,
            sendingOtp: '',
            genderOptions: [
                { value: 'M', label: 'Male' },
                { value: 'F', label: 'Female' },
                { value: 'O', label: 'Others' }
            ],
            maritalStatusOptions: [
                { label: 'Married', value: 'Married' },
                { label: 'Unmarried', value: 'Unmarried' },
                { label: 'Divorced', value: 'Divorced' }
            ]
        };
    },
    methods: {
        disabledDateAfterToday (date) {
            const today = new Date();
            return date > today;
        },
        verifyEmail (email) {
            this.sendOtp('email', email);
        },
        verifyPhone (phone) {
            this.sendOtp('phone', phone);
        },
        async sendOtp (type, target) {
            if (this.sendingOtp) return;
            this.sendingOtp = type;
            try {
                await axios.form(this.sendOtpUrl, { type, target });
                this.otpType = type;
                this.otpTarget = target;
                this.otpKey++;
                this.$refs.verifyModal.show();
            } catch (e) {
                this.$notify('Could not send OTP. Try again.', 'Error', { type: 'danger' });
            } finally {
                this.sendingOtp = '';
            }
        },

        resendOtp () {
            this.sendOtp(this.otpType, this.otpTarget);
        },

        otpSuccess () {
            if (this.otpType === 'email') this.emailVerified = true;
            else this.phoneVerified = true;
            this.$notify(`${this.otpType === 'email' ? 'Email' : 'Phone'} verified`, 'Success', {
                type: 'success'
            });
            this.$refs.verifyModal.close();
        },

        otpError () {
            this.$notify('Invalid or expired OTP', 'Error', { type: 'danger' });
        },
        formSuccess () {
            this.$notify('Registered Successfully', 'Success', {
                type: 'success'
            });
            setTimeout(() => {
                this.$router.push('/login/');
            }, 2000); // 2000 ms = 2 seconds
        },
        formError (response) {
            const data = response.data;
            if (data.message) {
                this.$notify(data.message, 'Failed', {
                    type: 'danger'
                });
            } else if (data.errors) {
                this.$refs.formValidator.setErrors(data.errors);
            } else {
                this.$notify('There were some errors while communicating with the server. Please refresh the page or try again later.', 'Failed', {
                    type: 'danger'
                });
            }
        }
    }
};
</script>

<style scoped lang="scss">
.verify-wrap {
    --verify-input-h: 45px; /* height of your input box, adjust to match */
    position: relative;

    /* Button and verified label: right side, vertically centred on the input */
    .verify-btn,
    .verify-done {
        position: absolute;
        top: calc(var(--verify-input-h) / 2);
        right: 10px;
        transform: translateY(-50%);
        z-index: 5;
        height: 28px;
        line-height: 26px;
        padding: 0 16px;
        font-size: 12px;
        font-weight: 600;
    }

    /* Verify button, same green as the Register button */
    .verify-btn {
        background: #3f9b59;
        color: #fff;
        border: 1px solid rgba(255, 255, 255, .6);
        border-radius: 0; /* use 3px if Register has rounded corners */
        cursor: pointer;
        transition: background .2s;

        &:hover:not(:disabled) {
            background: #348a4c;
        }

        &:focus {
            outline: none;
        }

        &:disabled {
            opacity: .6;
            cursor: not-allowed;
        }
    }

    /* Shown after verification */
    .verify-done {
        background: transparent;
        color: #fff;
        border: 0;
        cursor: default;
    }

    /* Keep typed text from running under the button */
    ::v-deep input {
        padding-right: 100px;
    }

    /* Chrome autofill: replace the pale blue with the form's green */
    ::v-deep input:-webkit-autofill,
    ::v-deep input:-webkit-autofill:hover,
    ::v-deep input:-webkit-autofill:focus,
    ::v-deep input:-webkit-autofill:active {
        -webkit-text-fill-color: #fff;
        caret-color: #fff;
        -webkit-box-shadow: 0 0 0 1000px #5f9f72 inset !important;
        box-shadow: 0 0 0 1000px #5f9f72 inset !important;
        transition: background-color 9999s ease-in-out 0s;
    }
}
.section-2 {
    background-image: url("../assets/web/register/bgi.png");
    background-position: center 100%;
    background-size: cover;
    background-repeat: no-repeat;
    min-height: 100vh;
}

.num-hide {
    -webkit-appearance: none;
}

.container {
    color: white;
}

.i-icon {
    position: absolute;
    top: 56px;
    right: -8px;
}

.logo {
    height: 78px;
    width: 148px;
}

.fb {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: white;
    border: 1px solid green;
    padding: 4px;

}

.gugl {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: white;
    border: 1px solid green;
    padding: 4px;

}

.mg {
    margin-top: -48px;
}

.icon-set {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: white;
    border: 1px solid green;
    padding: 4px;

}

.place-holder-white {

    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        /*/ / color: white !important;*/
        color: rgba(255, 255, 255, 0.7) !important;
        opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        /*/ / color: white !important;*/
        color: rgba(255, 255, 255, 0.7) !important;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        /*/ / color: white !important;*/
        color: rgba(255, 255, 255, 0.7) !important;
    }

}

.bdr-radius {
    border-radius: 2px;
}

.icon-white {

    svg {
        color: white !important;
    }

}

/*..mx-icon-calendar*/
.mx-icon-calendar, .mx-icon-clear {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    font-size: 16px;
    line-height: 1;
    color: white !important;
    vertical-align: middle;
}

@media (max-width: 750px) {
    .margin-1 {
        margin-top: 40px;
    }
}
.verify-spinner {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 6px;
    border: 2px solid rgba(255, 255, 255, .4);
    border-top-color: #fff;
    border-radius: 50%;
    animation: verify-spin .7s linear infinite;
    vertical-align: -1px;
}

@keyframes verify-spin {
    to { transform: rotate(360deg); }
}

</style>
